// Config centralizada de qué usuario es "admin" del lado del frontend.
//
// El control real de permisos vive en las reglas de Firestore
// (claude/firestore.rules.txt -> función isAdmin()), que usan el mismo
// email hardcodeado. Este archivo solo decide qué ve la UI (mostrar el
// botón de Admin en el Sidebar, dejar entrar a /admin): nunca reemplaza
// a las reglas del backend, que son las que de verdad protegen los datos.
export const ADMIN_EMAIL = "admin@admin.com";

export const isAdminEmail = (email?: string | null): boolean =>
  Boolean(email) && email === ADMIN_EMAIL;
